import MobileDetect from 'mobile-detect';

const mobileDetect = new MobileDetect(window.navigator.userAgent);
const isAndroidOS = mobileDetect.is("AndroidOs") === true;
const isIOS = mobileDetect.is("iOS") === true;

export { mobileDetect, isAndroidOS, isIOS };
